.previewImage {
  margin-top: 1em;
}
